(function () {
  var cache = {};
  function toMemory(v) {
    var url = v.getAttribute('src') || v.dataset.src;
    if (!url || v.dataset.mem) return;
    v.dataset.mem = 'loading';
    var p = cache[url] || (cache[url] = fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw 0; return r.blob(); }).then(function (b) { return URL.createObjectURL(b); }));
    p.then(function (obj) {
      var t = v.currentTime || 0, playing = !v.paused;
      v.src = obj; v.dataset.mem = '1';
      v.addEventListener('loadedmetadata', function once() { v.removeEventListener('loadedmetadata', once); try { v.currentTime = t; } catch (e) {} if (playing || !v.hidden) play(v); });
      v.load();
    }).catch(function () { v.dataset.mem = 'fail'; });
  }
  function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function seamless(v) {
    if (v.dataset.seamless) return; v.dataset.seamless = '1';
    v.loop = true; v.muted = true; v.playsInline = true; v.preload = 'auto';
    v.addEventListener('ended', function () { try { v.currentTime = 0; } catch (e) {} play(v); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden && !v.hidden && v.paused) play(v); });
  }
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var TIPS = { hb: 'Your 4-in-1 beauty secret! Use as brow gel, clear mascara, lash curl holder & lip balm.', gl: 'A little on your cheekbones for a natural highlight!', rw: 'Dab on your cheeks for a long-lasting rosy glow!' };
    var NAMES = { hb: 'Honey Bare', gl: 'Glow', rw: 'Rosewood', wc: 'Wild Cherry' };
    var q = function (s) { return root.querySelectorAll(s); };
    function playVisible() {
      q('[data-hero]').forEach(function (el) {
        if (el.tagName !== 'VIDEO') return;
        if (el.hidden) { el.pause(); return; }
        if (!el.getAttribute('src') && el.dataset.src) el.src = el.dataset.src;
        seamless(el); play(el); toMemory(el);
      });
    }
    function setShade(k) {
      q('[data-pick]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.pick === k ? 'true' : 'false'); });
      q('[data-hero]').forEach(function (el) { el.hidden = el.dataset.hero !== k; });
      q('[data-shade-name]').forEach(function (e) { e.textContent = NAMES[k]; });
      var tip = root.querySelector('[data-tip]');
      if (tip) {
        if (TIPS[k]) { tip.hidden = false; tip.querySelector('[data-tip-text]').textContent = TIPS[k]; tip.classList.remove('is-in'); void tip.offsetWidth; tip.classList.add('is-in'); }
        else tip.hidden = true;
      }
      root.dataset.shade = k;
      playVisible();
    }
    q('[data-pick]').forEach(function (b) { b.addEventListener('click', function () { setShade(b.dataset.pick); }); });
    q('[data-ba-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.baPick;
        q('[data-ba-pick]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        q('[data-ba]').forEach(function (img) { img.hidden = img.dataset.ba !== k; });
        q('[data-ba-name]').forEach(function (e) { e.textContent = NAMES[k]; });
      });
    });
    var top = root.querySelector('[data-layer-top]'), one = root.querySelector('[data-layer-one]'), bar = root.querySelector('[data-layer-bar]'), range = root.querySelector('[data-layer-range]');
    function wipe(v) { if (top) top.style.clipPath = 'inset(0 0 0 ' + v + '%)'; if (bar) bar.style.left = v + '%'; }
    if (range) { range.addEventListener('input', function () { wipe(range.value); }); wipe(range.value); }
    q('[data-layer-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        q('[data-layer-pick]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (one) { one.src = b.dataset.one; one.alt = b.dataset.name + ', one layer'; }
        if (top) { top.src = b.dataset.two; top.alt = b.dataset.name + ', two layers'; }
      });
    });
    q('[data-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type=email]'), err = form.querySelector('[data-err]'), btn = form.querySelector('button[type=submit]');
        var email = (input && input.value || '').trim();
        if (!/.+@.+\..+/.test(email)) { if (err) { err.hidden = false; err.textContent = 'Please enter a valid email address.'; } return; }
        if (err) err.hidden = true;
        var shade = NAMES[root.dataset.shade] || '';
        var kit = form.dataset.kit, redirect = form.dataset.redirect;
        var finish = function () {
          if (redirect) { location.href = redirect + (redirect.indexOf('?') < 0 ? '?' : '&') + 'shade=' + encodeURIComponent(shade); return; }
          q('[data-form]').forEach(function (f) { f.hidden = true; });
          q('[data-thanks]').forEach(function (t) { t.hidden = false; });
          q('[data-sticky]').forEach(function (s) { s.hidden = true; });
        };
        if (!kit) { console.warn('[sapienne] Kit form ID not set; nothing submitted.'); finish(); return; }
        if (btn) btn.disabled = true;
        var fd = new FormData();
        fd.append('email_address', email);
        fd.append('fields[shade]', shade);
        fetch('https://app.kit.com/forms/' + encodeURIComponent(kit) + '/subscriptions', { method: 'POST', body: fd, mode: 'no-cors' })
          .then(finish)
          .catch(function () { if (btn) btn.disabled = false; if (err) { err.hidden = false; err.textContent = 'Something went wrong. Please try again.'; } });
      });
    });
    playVisible();
  }
  function boot() { document.querySelectorAll('[data-s3]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
